// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteSharedGlobalIdUpsearchModel {
    static getAttributeTypeMap() {
        return SiteSharedGlobalIdUpsearchModel.attributeTypeMap;
    }
}
SiteSharedGlobalIdUpsearchModel.discriminator = undefined;
SiteSharedGlobalIdUpsearchModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "globalIdTypeCode",
        "baseName": "globalIdTypeCode",
        "type": "string"
    },
    {
        "name": "globalId",
        "baseName": "globalId",
        "type": "string"
    }
];
//# sourceMappingURL=siteSharedGlobalIdUpsearchModel.js.map